var _defs, _path, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpaceFavNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "0%",
    y: "0%",
    width: "100%",
    height: "100%",
    id: "272df5f5be"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0",
    colorInterpolationFilters: "sRGB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "8ea2158c69"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#272df5f5be)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3,
    width: 36,
    fill: "#000000",
    y: -3,
    height: 36.000001,
    fillOpacity: 0.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "c9f37a2aa7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.359375 0.179688 L 19.640625 0.179688 L 19.640625 20.386719 L 0.359375 20.386719 Z M 0.359375 0.179688 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0efdbd7b97"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 20,
    y: 0,
    height: 21
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "28ee72b90a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 4.457031 2.730469 L 25.507812 2.730469 L 25.507812 25.957031 L 4.457031 25.957031 Z M 4.457031 2.730469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "1ff0c3cff2"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#272df5f5be)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -3,
    width: 36,
    fill: "#000000",
    y: -3,
    height: 36.000001,
    fillOpacity: 0.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "f76acb17b0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.457031 1 L 21.507812 1 L 21.507812 23.957031 L 0.457031 23.957031 Z M 0.457031 1 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a2c13cea76"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.457031 0.730469 L 21.507812 0.730469 L 21.507812 23.957031 L 0.457031 23.957031 Z M 0.457031 0.730469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3c30d247f2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 22,
    y: 0,
    height: 24
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0576667, 0, 0, 0.056926, 4.457923, 2.732082)",
    fillOpacity: 1,
    fill: "#00438e",
    fillRule: "nonzero",
    strokeLinejoin: "miter",
    d: "M 208.41573 301.075296 C 192.835888 310.270347 173.598168 310.407587 157.882849 301.487014 L 111.346535 275.137015 C 95.631216 266.216443 85.876879 249.610454 85.741402 231.563449 L 85.334972 178.108633 C 85.199495 160.061629 94.682877 143.3184 110.194982 134.191968 L 156.324864 107.087152 C 171.904707 97.8921 191.142426 97.75486 206.857746 106.675433 L 253.394059 133.025432 C 269.041641 141.946004 278.795977 158.483374 278.999192 176.530378 L 279.405623 230.053814 C 279.5411 248.100818 270.057717 264.844047 254.477875 273.970479 Z M 86.622002 231.083111 C 86.757479 249.130115 96.511816 265.736104 112.227135 274.588057 L 157.882849 300.457718 C 173.598168 309.37829 192.835888 309.241051 208.41573 300.045999 L 253.597275 273.49014 C 269.177118 264.295089 278.6605 247.55186 278.525023 229.504856 L 278.118593 177.079337 C 277.915377 159.032332 268.161041 142.426343 252.51346 133.50577 L 206.857746 107.70473 C 191.142426 98.784157 171.904707 98.921397 156.324864 108.047829 L 111.14332 134.672307 C 95.563477 143.798739 86.080095 160.541967 86.215572 178.588972 Z M 86.622002 231.083111 ",
    stroke: "#00438e",
    strokeWidth: 12.628,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#8ea2158c69)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 5, 4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0efdbd7b97)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00438e",
    d: "M 11.601562 18.460938 C 10.640625 19.019531 9.449219 19.027344 8.480469 18.484375 L 3.664062 15.792969 C 2.695312 15.25 2.09375 14.238281 2.082031 13.136719 L 2.039062 7.675781 C 2.03125 6.574219 2.617188 5.554688 3.578125 4.996094 L 8.347656 2.226562 C 9.308594 1.667969 10.496094 1.660156 11.46875 2.203125 L 16.28125 4.894531 C 17.25 5.4375 17.855469 6.449219 17.863281 7.550781 L 17.90625 13.011719 C 17.917969 14.113281 17.332031 15.132812 16.367188 15.691406 Z M 2.15625 13.09375 C 2.164062 14.195312 2.765625 15.207031 3.738281 15.75 L 8.476562 18.402344 C 9.449219 18.945312 10.636719 18.9375 11.597656 18.378906 L 16.296875 15.652344 C 17.257812 15.09375 17.84375 14.070312 17.835938 12.972656 L 17.792969 7.59375 C 17.78125 6.492188 17.179688 5.480469 16.210938 4.9375 L 11.46875 2.285156 C 10.5 1.742188 9.308594 1.75 8.347656 2.308594 L 3.652344 5.035156 C 2.691406 5.59375 2.101562 6.617188 2.113281 7.714844 Z M 2.15625 13.09375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c9f37a2aa7)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0576667, 0, 0, 0.056926, -0.542077, -1.267918)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 210.58336 346.570216 C 193.919702 356.382846 173.259476 356.520085 156.460341 346.981935 L 72.938835 299.7029 C 56.139701 290.164749 45.70798 272.392224 45.504764 253.041443 L 44.759641 157.110978 C 44.624165 137.760197 54.784932 119.850432 71.44859 110.037802 L 154.157234 61.386372 C 170.820892 51.573742 191.41338 51.436502 208.280253 60.974653 L 291.73402 108.253688 C 308.533155 117.791839 319.032614 135.564364 319.168091 154.915145 L 319.913214 250.84561 C 320.116429 270.196391 309.955662 288.106155 293.224266 297.918785 Z M 46.791795 252.286626 C 46.927272 271.637406 57.358993 289.409931 74.225866 298.948082 L 156.392602 345.540919 C 173.259476 355.07907 193.851964 354.94183 210.515622 345.1292 L 292.004974 297.232587 C 308.668632 287.419958 318.829399 269.441573 318.693922 250.159412 L 317.948799 155.669962 C 317.745584 136.319182 307.313863 118.546656 290.514728 109.008506 L 208.280253 62.415669 C 191.481118 52.877518 170.820892 53.014758 154.157234 62.827387 L 72.73562 110.724 C 56.071962 120.53663 45.843457 138.515015 46.046672 157.797176 Z M 46.791795 252.286626 ",
    stroke: "#00438e",
    strokeWidth: 12.628,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#28ee72b90a)"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#1ff0c3cff2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 4, 2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3c30d247f2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f76acb17b0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00438e",
    d: "M 12.898438 22.820312 C 11.777344 23.46875 10.390625 23.480469 9.257812 22.847656 L 2.753906 19.210938 C 1.625 18.574219 0.917969 17.394531 0.910156 16.109375 L 0.847656 8.730469 C 0.839844 7.449219 1.523438 6.253906 2.644531 5.605469 L 9.089844 1.863281 C 10.210938 1.214844 11.597656 1.203125 12.730469 1.835938 L 19.234375 5.472656 C 20.363281 6.105469 21.066406 7.289062 21.078125 8.570312 L 21.136719 15.949219 C 21.148438 17.234375 20.464844 18.425781 19.34375 19.078125 Z M 1 16.058594 C 1.011719 17.339844 1.714844 18.523438 2.847656 19.15625 L 9.257812 22.742188 C 10.390625 23.375 11.777344 23.363281 12.898438 22.714844 L 19.25 19.027344 C 20.371094 18.375 21.054688 17.183594 21.046875 15.898438 L 20.984375 8.625 C 20.976562 7.339844 20.273438 6.160156 19.140625 5.527344 L 12.730469 1.941406 C 11.597656 1.308594 10.210938 1.320312 9.089844 1.96875 L 2.738281 5.65625 C 1.617188 6.308594 0.933594 7.5 0.941406 8.785156 Z M 1 16.058594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a2c13cea76)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.0576667, 0, 0, 0.056926, 0.457923, 0.732082)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 215.731482 388.016569 C 196.290548 399.407454 172.243399 399.613313 152.59925 388.496907 L 39.814735 324.611884 C 20.238324 313.426858 7.977665 292.703682 7.842188 270.127771 L 6.758373 140.504989 C 6.622896 117.997698 18.477124 97.000043 37.918058 85.609158 L 149.686496 19.8714 C 169.127431 8.480515 193.17458 8.274655 212.818729 19.391061 L 325.603244 83.276085 C 345.179655 94.392491 357.372576 115.184287 357.575791 137.691578 L 358.591868 267.31436 C 358.795083 289.89027 346.940855 310.819306 327.49992 322.278811 Z M 9.400172 269.235714 C 9.603387 291.743004 21.796308 312.534801 41.440458 323.651206 L 152.59925 386.644173 C 172.243399 397.760579 196.290548 397.554719 215.731482 386.163834 L 325.874198 321.386753 C 345.315132 309.927249 357.16936 288.998213 357.033883 266.422302 L 355.950068 138.652255 C 355.814591 116.076344 343.621671 95.353168 323.977521 84.236762 L 212.818729 21.243795 C 193.17458 10.12739 169.127431 10.333249 149.686496 21.724134 L 39.543781 86.501215 C 20.102847 97.96072 8.248619 118.889755 8.384095 141.465666 Z M 9.400172 269.235714 ",
    stroke: "#00438e",
    strokeWidth: 12.628,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaceFavNew);
export default __webpack_public_path__ + "static/media/spaceFavNew.ad20cd152d08bf7bce4a5863f1cf5c08.svg";
export { ForwardRef as ReactComponent };